<template>
  <h2 class="font-bold">
    {{ $t("toast.guidedNavigation.overlayTitle") }}
  </h2>
  {{ $t("toast.guidedNavigation.overlayMessage") }}
  <br />
  <button class="font-bold underline element-focusable" @click="triggerCta">
    {{ $t("toast.guidedNavigation.overlayDone") }}
  </button>
</template>
<script setup lang="ts">
import { useUILayers } from "@/components/UILayers";

const emits = defineEmits<{
  (e: "ctaTriggered"): void;
}>();

const { close } = useUILayers();

function triggerCta() {
  close();
  emits("ctaTriggered");
}
</script>
